module.exports = __webpack_public_path__ + "assets/media/level-03.332859d3.png";